import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { Facebook, FacebookLoginResponse } from '@awesome-cordova-plugins/facebook/ngx';
import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { BehaviorSubject, Subject } from 'rxjs';
// import { CategoryModel } from '../categories/categories';
import { ConfigProvider } from '../config/config';
import { RequestProvider } from '../request/request';
import { ResultListModel } from '../result/result';
import { SessionProvider } from '../session/session';
// import { Pager } from '../event/event';
import { NotificationProvider } from '../notification/notification';
import { AppDetectorProvider } from '../detector/detector';
import { StorageProvider } from '../storage-service/storage-service';
import { Cache } from '../../assets/data/cache-key/cache-key'; 
import { GlobalUtil } from '../../tracker/global-utils';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IFirebaseService } from 'src/core/services/firebase/firebase.service.interface';
import { FirebaseServiceFactory } from 'src/core/services/firebase/firebase.factory';


/*
  Generated class for the UserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

declare var cordova: any;


@Injectable({providedIn:'root'})
export class UserProvider {
	private readonly IMAGE_UPLOAD_PERMISSION_KEY = "isPhotoUploadAllowedKey";
	public notification: NotificationProvider;
	public isPhotoUploadAllowed: boolean = false;
	private firebaseService: IFirebaseService;

	constructor(
		public request: RequestProvider,
		public config: ConfigProvider,
		public storage: Storage,
		private fb: Facebook,
		private googlePlus: GooglePlus,
		private device: Device,
		public translate: TranslateService,
		private sessionService: SessionProvider,
		private platform: Platform,
		private toastCtrl: ToastController,
		private strg: StorageProvider,
		private router:Router,
		public navCtrl:NavController,
		private httpClient:HttpClient,
		private firebaseServiceFactory: FirebaseServiceFactory,
		private notificationService: NotificationProvider,
	) { 
		this.firebaseService = this.firebaseServiceFactory.create();
		this.isPhotoUploadAllowed = this.getPermission4ImageUpload();
	}

	private async getNotificationToken() {
		this.device.platform.toLowerCase();

		let obj = {};
		await this.strg.create();
		return await this.strg._storage.get('notificationToken');
	}

	public enableImageUpload(){
		localStorage.setItem(this.IMAGE_UPLOAD_PERMISSION_KEY, "true");
	}

	public disableImageUpload(){
		localStorage.setItem(this.IMAGE_UPLOAD_PERMISSION_KEY, "false");
	}

	

	async sendNotificationToken(notificationToken: string): Promise<number> {
		let phoneType = this.platform.is('ios') ? 2 : 1;;
		let appName = (await this.config.config).appId;
		return this.request.getApiSimple<number>('addnotitoken?phoneType=' + phoneType + '&appName=' + appName + '&notificationToken=' + notificationToken);
	}

	public async checkLoged(notificationToken = null) {
		console.log('checkLoged', notificationToken)
		return new Promise((resolve, reject) => {
			this.sessionService.getToken(true, false).then(async token => {
				console.log('checkLoged token', token)
				if (token) {
					console.log('this.sessionService.isLoged', this.sessionService.isLoged)
					// if (this.sessionService.isLoged) {
					// 	resolve(true);
					// } else {
						const reqObj: any = { token: token };
						if (!notificationToken) { resolve(null); return; }
						const notiToken = notificationToken;
						console.log('notiToken: ' + JSON.stringify(notiToken));
						console.log('n-1');
						let phoneType = 1;
						if(this.platform.is('ios')&&!this.platform.is('pwa')){
							phoneType = 2
						}
						if (notiToken) {
							reqObj.notificationToken = notiToken;
							reqObj.phone = phoneType;
							reqObj.appName = (await this.config.config).appId;
						}
						console.log('reqObj: ' + JSON.stringify(reqObj));
						console.log('n-2');
						if (!navigator.onLine) {
							this.strg.getSaved(Cache.PROFILE_TOKEN).then(localToken => {
								console.log('check loged is token.authToken: ' + localToken.authToken);
								if (localToken) {
									this.setToken(localToken.authToken).then(() => {
										this.sessionService.isLoged = true;
										console.log('check loged isLoged = true ');
										resolve(true);
									});
								} else {
									resolve(false);
								}
							});
						} else{
							console.log('call update createPostApiPromise')
							this.request
							.createPostApiPromise(
								'login/n/update',
								null,
								{
									headers: new HttpHeaders({
										'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
									}),
									params: reqObj
								},
								'spooortsWebApp'
							)
							.then(
								(token: LoginResponse) => {
									console.log('n-3, token: ' + JSON.stringify(token));
									if (token && token.authToken) {
										this.setToken(token.authToken).then(() => {
											this.sessionService.isLoged = true;
											this.strg.saveData(token, Cache.PROFILE_TOKEN);
											resolve(true);
										});
									} else {
										this.strg.create().then(()=>{
											this.strg._storage.remove('token');
										});
										resolve(false);
									}
								},
								error => {
									this.logoutOnError(error);
									resolve(false);
									console.log('cannot login reject', error);
								}
							)
							.catch(error => {
								resolve(false);
							});
						}
					// }
				} else {
					// console.log('User is not logged in, send notification token without lid and token')
					// const reqObj: any = { };
					// if (!notificationToken) { resolve(null); return; }
					// const notiToken = notificationToken;
					// console.log('notiToken: ' + JSON.stringify(notiToken));
					// console.log('n-1');
					// if (notiToken) {
					// 	reqObj.notificationToken = notiToken;
					// 	reqObj.phone = this.platform.is('ios') ? 2 : 1;
					// 	reqObj.appName = (await this.config.config).appId;
					// }
					// console.log('call update createPostApiPromise')
					// this.request
					// .createPostApiPromise(
					// 	'login/n/update',
					// 	null,
					// 	{
					// 		headers: new HttpHeaders({
					// 			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					// 		}),
					// 		params: reqObj
					// 	},
					// 	'spooortsWebApp'
					// )
					// .then(
					// 	(token: LoginResponse) => {
					// 		console.log('n-3, token: ' + JSON.stringify(token));
					// 		if (token && token.authToken) {
					// 			this.setToken(token.authToken).then(() => {
					// 				this.sessionService.isLoged = true;
					// 				this.strg.saveData(token, Cache.PROFILE_TOKEN);
					// 				resolve(true);
					// 			});
					// 		} else {
					// 			this.strg.create().then(()=>{
					// 				this.strg._storage.remove('token');
					// 			});
					// 			resolve(false);
					// 		}
					// 	},
					// 	error => {
					// 		this.logoutOnError(error);
					// 		resolve(false);
					// 		console.log('cannot login reject', error);
					// 	}
					// )
					// .catch(error => {
					// 	resolve(false);
					// })
					resolve(false);
				}
			});
		});
	}

	
	public logoutOnError(error: HttpErrorResponse): boolean {
		if (error.status === 404) {
			this.navCtrl.navigateForward('/auth/login', { replaceUrl: true });
			return true;
		}
		return false;
	}

	public setToken(token): Promise<string> {
		return new Promise((resolve, reject) => {
			if (token.length > 0) localStorage.setItem('token', token);
			this.strg.create().then(()=>{
				this.strg._storage.set('token', token).then(() => {
					this.getPrivateProfile().then((profile: PrivateProfile) => {
						this.sessionService.profile = profile;
						this.sessionService.isLoged = true;

						resolve(token);
					});
				});
			})
		});
	}
	init(){
		this.strg.create().then(()=>{
			this.strg._storage.get("token").then(result => {
				if (result) {
					this.getPrivateProfile();
				}
			})
		})
	}

	public setTokenID(tokenID): Promise<string> {
		return new Promise((resolve, reject) => {
			localStorage.setItem('token', tokenID);
			this.strg.create().then(()=>{
				this.strg._storage.set('tokenID', tokenID).then(() => {
					resolve(tokenID);
				});
			})
		});
	}

	removeAccount(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			this.sessionService.getToken(false, false).then(token => {
				this.request
					.createPostApiPromise(
						'keycloak/user/delete/' + token,
						null,
						{
							headers: new HttpHeaders({
								'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
							})
						},
						"loginUrl"
					).then(() => {
						resolve(true);
					}).catch(() => {
						resolve(false);
					});
					this.sessionService.deleteLogin();
				resolve(true);
			})
				.catch(() => {
					resolve(false);
				})
		});
	}
	public getPrivateProfile(): Promise<PrivateProfile> {
		console.log('getPrivateProfile: ');
		return new Promise((resolve, reject) => {
			this.sessionService.getToken(false, false).then(async token => {
				let params = new HttpParams();
				let url = environment.creatoradminApi + `user/${token}`;
				console.log('url: ' + url);
				if (!navigator.onLine) this.strg.getSaved(Cache.PRIVATE_PROFILE).then(r => {
					console.log('profile JSON: ' + JSON.stringify(r));
					this.sessionService.profile = r;
					this.sessionService.isLoged = true;
					resolve(r);
				});
				else this.request
					.get(url, {
						params: params
					})
					.toPromise()
					.then((values: PrivateProfile) => {
						let prof = values || {
							anrede: '',
							area: '',
							birthday: null,
							premium: false,
							city: '',
							country: '',
							forName: '',
							phoneType: '',
							id: -1,
							profilePicLink: '',
							homeStreet: '',
							homeStreetNo: '',
							clubName: '',
							resultVec: [],
							status: '',
							surName: '',
							themeName: 'wood',
							zip: '',
							title: '',
							contents: '',
							facebookLnk: '',
							instaLnk: '',
							youtubeLnk: '',
							whatsappLnk: '',
							twitterLnk: '',
							linkedinLnk: '',
							xingLnk: '',
							socialLnk: '',
							logoImg: ''
						};

						this.sessionService.profile = prof;
						this.sessionService.isLoged = true;
						console.log('prof: ', prof);
						if (this.sessionService.profile.birthday === -1) {
							this.sessionService.profile.birthday = null;
						}
						this.strg.saveData(this.sessionService.profile, Cache.PRIVATE_PROFILE);
						resolve(this.sessionService.profile);
					})
					.catch(error => {
						console.log(error);
						throw 'cannot get dtrange';
					});
			});
		});
	}

	public registerById(email: string, id: string): Promise<any> {
		return new Promise(async (resolve, reject) => {
			this.registration({
				email: email,
				password: "unset",
				password2: "unset"
			}).then((result) => {
				this.setTokenID(id).then(() => {
					// this.updateProfile(this.sessionService.profile).catch(err => console.log(err));
				});

				resolve(result);
			})
				.catch((err) => {
					console.log('Error while registering new account: ' + err);
					resolve(false);
				});
		});
	}

	registerFakeById() {
		return new Promise(async (resolve, reject) => {
			// this.registration({
			// 	email: email,
			// 	password: "unset",
			// 	password2: "unset"
			// }).then((result) => {
			this.setTokenID("fake-token-id").then(() => {
				// this.updateProfile(this.sessionService.profile).catch(err => console.log(err));
			});

			resolve("fake-token-id");
			// })
			// 	.catch((err) => {
			// 		console.log('Error while registering new account: ' + err);
			// 		resolve(false);
			// 	});
		});
	}

	public loginById(email: string, id: string): Promise<any> {
		return new Promise(async (resolve, reject) => {
			this.login({
				email: email,
				password: "unset"
			})
				.then((result) => {
					this.setTokenID(id).then(() => {
						// this.updateProfile(this.sessionService.profile).catch(err => console.log(err));
					});

					resolve(result);
				})
				.catch((err) => {
					console.log("Error while login in with id: " + err);
					resolve(err);
				});

		});
	}

	public registration(model: RegistrationModel): Promise<any> {
		console.log('model: ', model);
		return new Promise(async (resolve, reject) => {
			let params = new HttpParams({ fromObject: model });
			if (!navigator.onLine) this.strg.getSaved(Cache.PROFILE_TOKEN).then(token => {
				if (token) {
					this.setToken(token.authToken).then(() => {
						resolve(true);
					});
				} else {
					resolve(false);
				}
			});
			else{
				let loginForm:{password:string, email:string}={password:model.password, email:model['email']};
				const url =`${environment.loginApi}keycloak/register?email=${loginForm.email}&password=${loginForm.password}`;
				this.httpClient.post(url, null, {
					headers: new HttpHeaders({
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					}),
					responseType: 'text'
				})
				.toPromise()
				.then((res: any) => {
					console.log('registrationId', res);

					if (res) {
						console.log('Registration successfully with id:', res)
						// resolve(res)
						this.login(model).then(resAuth=>{
							if(resAuth){
								resolve({success:true});
							}else{
								resolve({success:false, message:"ERROR_IN_LOGIN"});
							}
						})
					} else {
						resolve({success:false, message:'ERROR_IN_REGISTRATION'});
					}
				})
				.catch(error => {
					console.error('Registration failed', error);
					resolve({success:false, message:'ERROR_IN_REGISTRATION'});
				});
			}
		});
	}

	public login(model: LoginModel): Promise<boolean> {
		return new Promise(async (resolve, reject) => {
			if (!navigator.onLine) this.strg.getSaved(Cache.PROFILE_TOKEN).then(token => {
				if (token) {
					this.setToken(token.authToken).then(() => {
						resolve(true);
					});
				} else {
					resolve(false);
				}
			});
			else{
				let loginForm:{password:string, email:string}={password:model.password, email:model['email']};
				const url = `${environment.loginApi}keycloak/login?email=${loginForm.email}&password=${loginForm.password}`;
				this.httpClient.post(url, null, {
					headers: new HttpHeaders({
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					}),
					responseType: 'text'
				})
				.toPromise()
				.then((token: any) => {
					console.log('login token', token);

					if (token) {
						localStorage.setItem("token", token);
						this.firebaseService.onTokenRefresh().subscribe(token=>{
							console.log('token refreshed when loggedIn', token)
							this.notificationService.registration.forEach(reg => reg.next(token));
						})
						this.sessionService.isLoged= true;

						if (model.password.includes("unset")) {
							this.setTokenID(token);
							resolve(true);
						} else {
							this.setToken(token).then(() => {
							this.strg.saveData({ authToken: token }, Cache.PROFILE_TOKEN);
							resolve(true);
							});
						}
					} else {
						resolve(false);
					}
				})
				.catch(error => {
					console.error('login failed', error);
					resolve(false);
				});
			}
		});
	}


	logout(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			localStorage.setItem("token", null);
			this.strg.create().then(()=>{
				this.strg._storage.remove('token');
				this.strg._storage.remove('tokenID' + GlobalUtil.getInstance().currentEventID);
				this.sessionService.isLoged = false;
				this.sessionService.sendLogout();
				this.sessionService.profile = null;
				resolve(true);
			})
		});
	}

	async getMyFriends(): Promise<MySportProfileListItem[]> {
		return this.sessionService.getToken().then(token => {
			if (!navigator.onLine) return this.strg.getSaved(Cache.FRIENDS_MY_TOKEN).then(r => r);
			else return this.request.getApiSimple(`user/${token}/friends`, {}, 2000, "sportevent").then(r => {
				this.strg.saveData(r, Cache.FRIENDS_MY_TOKEN);
				return r;
			});
		});
	}

	async getMyFeed(page, start, limit, isFriendFeed = false, spId?): Promise<any[]> {
		if (!navigator.onLine) return this.strg.getSaved(Cache.FRIENDS_MY_TOKEN).then(r => r);
		return this.request.getApiSimpleWithAuth<any[]>((isFriendFeed) ? `friend/${spId}/feed` : `feed`, { page: page, start: start, limit: limit }).then(r => {
			this.strg.saveData(r, Cache.FRIENDS_MY_TOKEN);
			return r;
		});
	}

	//DEPRECATED;
	async getMyFans(): Promise<MySportProfileListItem[]> {
		if (!navigator.onLine) return this.strg.getSaved(Cache.MYPICS_FANS).then(r => r);
		return this.request.getApiWithToken<MySportProfileListItem[]>('fans', {}, false, false).then(r => {
			this.strg.saveData(r, Cache.MYPICS_FANS);
			return r;
		});
	}

	async getMyPhotos(): Promise<MyPicsListModel[]> {
		return this.sessionService.getToken().then(token => {
			if (!navigator.onLine) return this.strg.getSaved(Cache.MYPICS_PHOTOS).then(r => r);
			return this.request.getApiSimple(`user/${token}/photos`, {}, 2000, "event").then(r => {
				console.log('getMyPhotos r', r)
				this.strg.saveData(r, Cache.MYPICS_PHOTOS);
				return r;
			});
		});
	}

	async getMyBibPhotos(): Promise<MyPicsListModel[]> {
		if (!navigator.onLine) return this.strg.getSaved(Cache.MYBIBS_PHOTOS).then(r => r);
		return this.request.getApiSimpleWithAuth<MyPicsListModel[]>(`bib/photos`).then(r => {
			this.strg.saveData(r, Cache.MYBIBS_PHOTOS);
			return r;
		});
	}

	/**
	 * 
	 * @deprecated
	 */
	async getMyShirtsPhotos(): Promise<MyPicsListModel[]> {
		return new Promise<any>((resolve, reject) => { resolve([]) })
		// if (!navigator.onLine) return this.strg.getSaved(Cache.MYSHIRTS_PHOTOS).then(r => r);
		// return this.request.getApiWithToken<MyPicsListModel[]>('myshirts', {}, false, false).then(r => {
		// 	this.strg.saveData(r, Cache.MYSHIRTS_PHOTOS);
		// 	return r;
		// });
	}

	removePhoto(photoId: number, routeEndpoint: boolean = false, token = null, routeName = null): Promise<boolean> {
		if (routeEndpoint) return this.removePhotoWithBody(photoId, token, routeName);
		else return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.sessionService.getToken(false, false).then(async (token: string) => {
				this.request
					.createPostApiPromise(`user/${token}/photo/delete/` + photoId, {}, { params: httpParams }, 'sportevent')
					.then(() => {
						resolve(true);
					})
					.catch(error => {
						resolve(false);
					});
			});
		});
	}

	removePhotoWithBody(photoId, token, routeName): Promise<boolean> {
		return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.request
				.createPostPromise(`${environment.routeApi}user/${token}/route/photo/${photoId}/delete?routeName=${routeName}`, {}, { params: httpParams })
				.then(() => {
					resolve(true);
				})
				.catch(error => {
					resolve(false);
				});
		});
	}

	removeEventPhoto(photoId: number, name: string = "", city: string = ""): Promise<boolean> {
		return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.sessionService.getToken(false, false).then(async (token: string) => {
				this.request
					.createPostApiPromise(`event/${photoId}/photo/delete`, null, { params: { token: token, name: name, city: city } })
					.then(() => {
						resolve(true);
					})
					.catch(error => {
						resolve(false);
					});
			});
		});
	}

	createPhoto(id: number, data: string, routeEndpoint, token = null, routeName = null) {
		return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.sessionService.getToken(false, false).then(async (token: string) => {
				if (routeEndpoint) {
					this.request
						.createPostApiPromise(`user/${token}/route/image/upload`, { id: id, imageLink: data, name: routeName }, { params: httpParams }, "route")
						.then((data: MyPicsListModel) => {
							resolve(data);
						})
						.catch(error => {
							console.log('error: ' + error);
							throw 'cannot upload image / uploadImg';
						});
				} else {
					console.log('token: ' + token);
					let imageLink = data.split('base64,')[1];
					console.log(JSON.stringify({ id: id, name: "pic" + new Date().getTime() + ".jpeg", imageLink: imageLink }));
					this.request
						.createPostApiPromise(`user/${token}/photo/upload`, { id: id, name: new Date().getTime() + ".jpeg", imageLink: imageLink }, { params: httpParams }, "admin")
						.then((data: MyPicsListModel) => {
							console.log('the pic is uploaded');
							resolve(data);
						})
						.catch(error => {
							console.log('error: ' + error);
							throw 'cannot upload image / uploadImg';
						});
				}

			});
		});
	}
	createPhotoWithBody(id: number, data: string, routeEndpoint): Promise<MyPicsListModel> {
		return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.sessionService.getToken(false, false).then(async (token: string) => {
				console.log('token: ' + token);
				httpParams = httpParams.append('token', token);
				let endpoint = (routeEndpoint) ? 'uploadRouteImg' : 'uploadImg';

				let body = {

				}
				this.request
					.createPostApiPromise(endpoint, { id: id, imageLink: data }, { params: httpParams })
					.then((data: MyPicsListModel) => {
						resolve(data);
					})
					.catch(error => {
						console.log('error: ' + error);
						throw 'cannot upload image / uploadImg';
					});
			});
		});
	}

	createPhotoWithToken(id: number, data: string, token: string): Promise<MyPicsListModel> {
		return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.request
				.createPostApiPromise(`user/${token}/photo/upload`, { id: id, imageLink: data }, { params: httpParams }, "admin")
				.then((data: MyPicsListModel) => {
					resolve(data);
				})
				.catch(error => {
					console.log('error: ' + error);
					throw 'cannot upload image / uploadImg';
				});
		});
	}

	uploadMyPhoto(imgModel, token) {
		return new Promise((resolve, reject) => {
			fetch(`${environment.backofficeApi}user/${token}/photo/upload`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(imgModel)
			})
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok: ' + response.statusText);
					}
					return response.text();
				})
				.then(data => {
					// Handle the response data here
					console.log(data);
					resolve(data);
				})
				.catch(error => {
					// Handle errors here
					console.error('There has been a problem with your fetch operation:', error);
					reject(error);
				});
		});
	}

	async addFriend(spid: number): Promise<{ id: number; imageLink: string; userName: string }[]> {
		return this.sessionService.getToken().then(token => {
			return this.request.getApiSimple<{ id: number; imageLink: string; userName: string }[]>(`user/${token}/friend/${spid}/add`, {}, 2000, "sportevent");
		});
	}

	async friendExist(spid: number): Promise<any> {
		return this.sessionService.getToken().then(token => {
			console.log('spid',spid)
			return this.request.getApiSimple(`user/${token}/friend/${spid}/exists`, {}, 2000, "sportevent");
		});
	}

	/**
	 * 
	 * @deprecated
	 */
	async thatsMe(spid: number): Promise<null> {
		// its returns null, with successed status if its ok, probably
		//retuns with some http error code if not.
		return this.request.getApiWithToken<null>('thm', { spid: spid });
	}

	removeFriend(rellid: number): Promise<boolean> {
		return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.sessionService.getToken(false, false).then((token: string) => {
				this.request
					.createPostApiPromise(`user/${token}/friend/delete/${rellid}`, null, { params: httpParams }, "sportevent")
					.then(() => {
						resolve(true);
					})
					.catch(error => {
						resolve(false);
					});
			});
		});
	}

	// async getPublicProfile(spId: number) {
	// 	return new Promise<any>((resolve, reject) => { 
	// 		if (!navigator.onLine) return this.strg.getSaved(Cache.PUBLIC_PROFILE_ID + spId).then(r => r);
	// 		else return this.request.getApiSimple(`sporthero/${spId}/profile/public`).then(r => {
	// 		this.strg.saveData(r, Cache.PUBLIC_PROFILE_ID + spId);
	// 		resolve(r);
	// 	}).catch(err => {
	// 		alert(err);
	// 		resolve(null);
	// 	})
	// 	});
	// 	// if (!navigator.onLine) return this.strg.getSaved(Cache.PUBLIC_PROFILE_ID + spId).then(r => r);
	// 	// else return this.request.getApiSimple(`sporthero/${spId}/profile/public`).then(r => {
	// 	// 	console.log('spid', spId)
	// 	// 	console.log('r',r)
	// 	// 	this.strg.saveData(r, Cache.PUBLIC_PROFILE_ID + spId);
	// 	// 	return r;
	// 	// }).catch(err => {
	// 	// 	alert(err);
	// 	// 	return null;
	// 	// })
	// }

	async getMyResults(profileRequired: boolean = true): Promise<ResultListModel[]> {
		if (!navigator.onLine) return this.strg.getSaved(Cache.MY_RESULTS_BY_TOKEN).then(r => r);
		return this.request.getApiSimpleWithAuth<ResultListModel[]>(`results/`).then(r => {
			this.strg.saveData(r, Cache.MY_RESULTS_BY_TOKEN);
			return r;
		});
	}

	async getUserPic(id): Promise<any> {
		if (!navigator.onLine) return this.strg.getSaved(Cache.USER_PIC_BY_ID + id).then(r => r);
		else return this.request.getApiSimple<any>(`sporthero/${id}/photo`).then(r => {
			this.strg.saveData(r, Cache.USER_PIC_BY_ID + id);
			return r;
		});
	}

	updateProfile(data: PrivateProfile): Promise<PrivateProfile> {
		console.log('data: ', data);
		return new Promise((resolve, reject) => {
			this.request
				.createPostApiPromiseWithAuth(`profile/save`, data, {})
				.then((prof: PrivateProfile) => {
					resolve(prof);
				})
				.catch(error => {
					resolve(null);
				});
		});
	}

	updateProfilePicture(id: number): Promise<boolean> {
		return new Promise((resolve, reject) => {
			let httpParams = new HttpParams();
			this.sessionService.getToken(false, false).then(async (token: string) => {
				this.request
					.createPostApiPromise(`/user/${token}/profilepic/${id}`, null, { params: httpParams }, "sportevent")
					.then(() => {
						resolve(true);
					})
					.catch(error => {
						resolve(false);
					});
			});
		});
	}

	private getPermission4ImageUpload(){
		const result = localStorage.getItem(this.IMAGE_UPLOAD_PERMISSION_KEY);
		return (result === "false" || !result) ? false : true;

	}
}


export interface LoginModel {
	[email: string]: string;
	password: string;
}

interface LoginResponse {
	authToken: string;
}

export interface PrivateProfile {
	anrede: string;
	area: string;
	birthday?: number;
	city: string;
	country: string;
	fanCount?: number;
	forName: string;
	phoneType: string;
	id: number;
	premium: boolean;
	clubName: string;
	profilePicLink: string;
	homeStreet: string;
	homeStreetNo: string;
	resultVec: ResultListModel[];
	sportFriendCount?: any;
	sportTypesVects?: any;
	status: string;
	surName: string;
	themeName: string;
	zip: string;
	title: string;
	contents: string;
	facebookLnk: string;
	instaLnk: string;
	youtubeLnk: string;
	whatsappLnk: string;
	twitterLnk: string;
	linkedinLnk: string;
	xingLnk: string;
	socialLnk: string;
	logoImg: string;
}

export interface MySportProfileListItem {
	id: number;
	imageLink: string;
	userName: string;
	lid?:number;
}

export interface PublicProfileModel {
	anrede: string;
	area: string;
	birthday: number;
	clubName: string;
	city: string;
	country: string;
	fanCount: number;
	phoneType: string;
	forName: string;
	homeStreet: string;
	homeStreetNo: string;
	id: number;
	profilePicLink: string;
	resultVec: ResultListModel[];
	sportFriendCount?: number;
	sportTypesVec?: any[];
	status: string;
	surName: string;
	themeName: string;
	zip: string;
	title: string;
	contents: string;
	facebookLnk: string;
	instaLnk: string;
	youtubeLnk: string;
	whatsappLnk: string;
	twitterLnk: string;
	linkedinLnk: string;
	xingLnk: string;
	socialLnk: string;
	logoImg: string;
}

export interface MyPicsListModel {
	id: number;
	imageLink: string;
}

export interface ReservationListModel {
	dateStrn: string;
	dt: number;
	gPlatz: number;
	gZeit: string;
	id: number;
	isClaimed: boolean;
	nameStrn: string;
	spId: number;
	templateData?: string;
	wName: string;
}

export interface RegistrationModel {
	[email: string]: string;
	password: string;
	password2: string;
}